const elementListeners: Map<HTMLElement, (event: TransitionEvent) => void> = new Map();

/**
 * Note this is expecting a CSS transition to be in
 * place for `$el`'s `height` property.
 */
function expandCollapse($el: HTMLElement, isExpanding: boolean) {
  const { style } = $el;
  const currentHeight = $el.clientHeight;

  if (elementListeners.has($el)) {
    const handler = elementListeners.get($el);

    if (handler) {
      $el.removeEventListener('transitionend', handler);
    }
  }

  const onTransitionEnd = (event: TransitionEvent) => {
    if (event.propertyName === 'height') {
      $el.removeEventListener('transitionend', onTransitionEnd);
      elementListeners.delete($el);

      style.removeProperty('height');

      if (!isExpanding) {
        style.setProperty('display', 'none');
      }
    }
  };

  $el.addEventListener('transitionend', onTransitionEnd);
  elementListeners.set($el, onTransitionEnd);

  let targetHeight = 0;

  if (isExpanding) {
    style.removeProperty('display');
    style.setProperty('height', 'auto');

    targetHeight = $el.clientHeight;
  }

  style.setProperty('height', `${currentHeight}px`);

  window.setTimeout(() => {
    style.setProperty('height', `${targetHeight}px`);
  }, 1);
}

function expand($el: HTMLElement) {
  expandCollapse($el, true);
}

function collapse($el: HTMLElement) {
  expandCollapse($el, false);
}

export default {
  expand,
  collapse,
};
